import React from 'react'

import classes from './Formula.scss'

import { Autocomplete } from '@material-ui/lab'
import { TextField, Button } from '@material-ui/core'

const Formula = ({ configs, formulaSelectValue, selectValueChanged, changed, inputValue, validations }) => {
  return (
    <div className={classes.Formula}>
      <div className={classes.SelectBar}>
        <div className={classes.Selector}>
          <Autocomplete
            options={configs?.options}
            getOptionLabel={option => (option.label ? option.label : '')}
            clearOnEscape
            value={formulaSelectValue}
            onChange={(event, value) => selectValueChanged(value)}
            renderInput={params => {
              return (
                <TextField
                  {...params}
                  disabled={configs?.disabled}
                  required={validations?.required}
                  label={''}
                  fullWidth
                />
              )
            }}
          />
        </div>
        <div className={classes.SelectButton}>
          <Button
            color={'primary'}
            disabled={!formulaSelectValue}
            onClick={() => changed(inputValue + `{{${formulaSelectValue.value}}}`)}>
            Select
          </Button>
        </div>
      </div>
      <div className={classes.FormulaButtonGroup}>
        <div className={classes.FormulaButton}>
          <Button color={'primary'} onClick={() => changed(inputValue + '+')}>
            +
          </Button>
        </div>
        <div className={classes.FormulaButton}>
          <Button color={'primary'} onClick={() => changed(inputValue + '-')}>
            -
          </Button>
        </div>
        <div className={classes.FormulaButton}>
          <Button color={'primary'} onClick={() => changed(inputValue + '*')}>
            ×
          </Button>
        </div>
        <div className={classes.FormulaButton}>
          <Button color={'primary'} onClick={() => changed(inputValue + '/')}>
            ÷
          </Button>
        </div>
        <div className={classes.FormulaButton}>
          <Button color={'primary'} onClick={() => changed(inputValue + '(')}>
            (
          </Button>
        </div>
        <div className={classes.FormulaButton}>
          <Button color={'primary'} onClick={() => changed(inputValue + ')')}>
            )
          </Button>
        </div>
      </div>
      <textarea
        className={classes.FormularTextArea}
        value={inputValue}
        onChange={e => changed(e.target.value)}
      />
    </div>
  )
}

export default Formula
